<template>
    <li>
        <img v-if="titleImage" :src="titleImage" class="quiz-app__questions__item__image">
        <header class="quiz-app__counterv2">Вопрос {{ questionIndex + 1 }}/{{ totalQuestions }}</header>
        <div class="quiz-app__questions__item" v-html="titleText"></div>
        <ul class="quiz-app__answers">
            <v-answer
                class="quiz-app__answers__item"
                v-for="answer in privateModel.answers"
                :key="answer.id"
                :model="answer"
                :multiple="isMultiple"
                :chosenAnswers="chosenAnswers"
                :isQuestionAnswered="isQuestionAnswered"
            ></v-answer>
        </ul>
        
        <transition-group name="slide-up" tag="div" class="quiz-app__questions__item__buttons text-center">
            <button
                class="button quiz-app__button"
                v-if="!chosenAnswers.length"
                disabled
                :key="1"
            >
                Выберите {{ !isMultiple ? 'вариант' : 'один или несколько вариантов' }} ответа
            </button>

            <button
                class="button quiz-app__button"
                v-if="!isQuestionAnswered && chosenAnswers.length"
                @click="checkAnswers"
                :key="2"
            >Ответить</button>
            <button
                class="button quiz-app__button"
                v-if="isQuestionAnswered && chosenAnswers.length"
                @click="quizNextQuestion"
                :key="3"
            >{{ !isLastQuestion ? 'Следующий вопрос' : 'Завершить тест' }}</button>
        </transition-group>
    </li>
</template>

<script>
import EventBus from '../shared/EventBus'
import VAnswer from '../components/VAnswer'

export default {
    name:'QuestionComponent',
    components: { VAnswer },
    props: {
        model: { required:true },
        isLastQuestion: { default:false },
        questionIndex: { type:Number, default:0 },
        totalQuestions: { type:Number, default:0 }
    },
    computed: {
        isMultiple(){ return this.privateModel.type == 1 },
        titleImage(){
            if(this.privateModel.image) return this.privateModel.image
            if(!this.privateModel.title) return null
            const match = this.privateModel.title.match(/<img[^>]+src=["']([^"']+)["'][^>]*>/i)
            return match ? match[1] : null
        },
        titleText(){
            if(!this.privateModel.title) return ''
            return this.privateModel.title.replace(/<img[^>]*>/gi, '').trim()
        }
    },
    data: () => ({
        privateModel:null, chosenAnswers:[], isQuestionAnswered:false
    }),
    created(){
        this.privateModel = JSON.parse(JSON.stringify(this.model))
        
        EventBus.$on('choose-answer', answerId => {
            if(
                this.privateModel.answers.find(answer => answer.id == answerId)
                && !this.isQuestionAnswered
            ){
                if(!this.isMultiple){
                    this.chosenAnswers = [answerId]
                } else {
                    if(!this.chosenAnswers.includes(answerId)){
                        this.chosenAnswers.push(answerId)
                    } else {
                        this.chosenAnswers.splice(this.chosenAnswers.indexOf(answerId), 1)
                    }
                }
            }
        })
    },
    methods: {
        checkAnswers(){
            this.isQuestionAnswered = true
            const correctVsChosen = [...this.privateModel.answers.filter(a => a.correct === 1).map(a => a.id)].sort().toString() === [...this.chosenAnswers].sort().toString()
            EventBus.$emit('check-question', correctVsChosen)
        },
        quizNextQuestion(){
            EventBus.$emit('next-question', this.chosenAnswers)
        }
    },
}
</script>

<style lang="scss">
    .slide-up-leave-active,
    .slide-up-enter-active { transition:all .2s ease!important }
    .slide-up-enter { position:absolute; top:100%; left:0 }
    .slide-up-enter-to { position:absolute; top:100%; left:0; transform:translate(0, calc(-100% - 16px)) }
    .slide-up-leave-to { transform:translate(0, calc(-100% - 16px)) }
</style>